import React from "react";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({
  redirectPath = `/login`,
  children,
}: {
  redirectPath?: string;
  children?: React.ReactElement;
}) => {
  const token = localStorage.getItem("auth-token");
  if (!token) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};
